import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ControlItem } from 'src/app/models/frontend';
import { RetailerHomeService } from '../retailer-home.service';
import { DiscountTemplatesService } from '../../discount-templates/discount-templates.service';
import { ProductService } from '../../products/product.service';
import { CookieService } from 'ngx-cookie-service';
import { CountryService } from '../../countries/country.service';
import { LocationsService } from '../../locations/locations.service';
import { UsersService } from '../../users/users.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-retailer-domestic',
  templateUrl: './retailer-domestic.component.html',
  styleUrls: ['./retailer-domestic.component.scss']
})
export class RetailerDomesticComponent {
  productForm: FormGroup
  recieversOptions: any
  countryOptions: any

  cityOptions: any
  productOptions: any

  retailerForm: FormGroup

  selectedCountryCode: string = "+1"; // Default country code
  phoneNumber: string = "";

  TopUpsByCustomerId: any

  //Country Items
  country: any
  intlcountryList: ControlItem[] = []

  CountryIso: any
  CountryName: any

  //ProviderItems
  ProviderCode: any
  ProviderName: any
  logoUrl: any

  providers: any
  intlprovidersOption: ControlItem[] = []

  //Product Items
  productRequest = {
    countryIso: "",
    providerCode: "",
    receiveCountryName: "",
    providerName: "",
    accountNumber: "",
    logoUrl: "",
    logRequest: true
  }
  Products: any
  intlproductsOption: ControlItem[] = []

  intlSelectedProduct: any
  intlSelectedProvider: any
  intlProductRefenceNumber: any
  intlProductUatNumber: any

  OrderItem: any = []
  ReProcessOrderItem: any = []

  CustomerPhoneNo: any;
  Customer_Sender_Id: any;

  //Domestic
  dmstcProductOptions: any
  dmstcProviderOptions: any
  dmstcProductRefenceNumber: any

  internationalEstimatePrice: any
  domesticEstimatePrice: any

  CustomerDetails: any
  customerFields = false

  recieverDetails: any
  recieverfirstName: any
  recieverlastName: any
  recieverEmail: any
  recieverMobile: any

  activeCountries: any
  activeLocations: any
  activeProducts: any
  activeSelectedCountry: any
  activeSelectedLocation: any
  activeSelectedProduct: any

  boolCustomerFirstName = false
  boolCustomerLastName = false
  boolCustomerMobile = false
  boolRecieverFirstName = false
  boolRecieverLastName = false
  boolRecieverMobile = false

  PridCustomerFirstName: any
  PridCustomerLastName: any
  PridCustomerMobileNumber1: any = ""
  PridCustomerEmail: any
  boolPridCustomerFirstName = true
  boolPridCustomerLastName = true

  ProductMinPrice: any
  ProductMaxPrice: any
  boolAmountRange = false;

  CartTotalAmount: number = 0
  PridRecieverId: any

  selectedItem = null;
  selectedItemProduct = null;

  boolShowAmount = false
  boolShowProvider = false
  domesticPhoneError = ""

  Loader = false
  numberLoader = 0

  Role: any = 0
  pridActiveCountries: ControlItem[] = []
  CountryValue = "Select Country"

  selectedCountry: string;
  phNumber: string;
  countries = [
  ];
  flagCountries = []
  SubmitOrderButton = false
  ProductRecieverId: number

  countryControl = new FormControl();
  filteredCountries: Observable<any>;
  countriesSearch: any[] = []; // Your array of countries

  TopupList: any
  imageURL = environment.imageUrl

  intlAmountValue: number = 0
  dmstcAmountValue: number = 0
  boolIntlAmountValue = false
  boolDmstcAmountValue = false
  countryFlagImg = ""
  internationalCountryCode = ""

  PridProductRecieverId:number=0
  DomesticMobileNumber:string

  @ViewChild('firstName') firstName: ElementRef;
  @ViewChild('lastName') lastName: ElementRef;
  @ViewChild('internationalAmountValue') internationalAmountValue: ElementRef;
  
  constructor(private fb: FormBuilder, public retailerService: RetailerHomeService,
    public countryService: CountryService, public customService: DiscountTemplatesService,
    public locationService: LocationsService, public productService: ProductService,
    public userService: UsersService, private cookieService: CookieService){

  }

  domesticNumberProcess(phone) {
    var phone=phone.replace(/-/g,'')
    this.Loader = true
    console.log(this.Loader)
    if (phone.length > 10) {
      this.domesticPhoneError = "Phone number not valid"
      this.Loader = false
      return
    }
    else if (phone.length < 10) {
      this.domesticPhoneError = "Phone number not valid"
      this.Loader = false
      return
    }
    else if (phone.length == 10) {
      this.domesticPhoneError = ""
      this.boolShowProvider = true
      this.GetDomesticProviders();
      this.Loader = false
    }
    this.Loader = false
  }

  async GetDomesticProviders() {
    this.Loader = true
    this.boolAmountRange = false
    this.CountryIso = "US"
    console.log(this.intlcountryList)
    const selectedCountry = this.intlcountryList.find(country => country.value === "US");
    console.log(selectedCountry)
    this.CountryName = selectedCountry.label
    this.intlprovidersOption = []
    this.customService.GetProviders("US").subscribe((res: any) => {
      console.log(res)
      this.providers = res
      this.dmstcProviderOptions = []
      for (let i = 0; i <= this.providers.length; i++) {
        this.dmstcProviderOptions.push({ value: this.providers[i].providerCode, label: this.providers[i].name, label2: this.providers[i].logoUrl })
      }
      console.log(this.dmstcProviderOptions)

    })

  }
  onItemClick(item, accountNumber) {
    this.selectedItem = null;
    if (this.selectedItem === item) {
      this.selectedItem = null; // If the same item is clicked, toggle it off
    } else {
      this.selectedItem = item; // Otherwise, set the clicked item as selected
    }
    this.GetDomesticProducts(item.value, accountNumber)
  }
  GetDomesticProducts(id, accountNumber) {
    this.Loader = true
    this.ProviderCode = id
    const selectedProviders = this.dmstcProviderOptions.find(provider => provider.value === id);
    this.intlSelectedProvider = selectedProviders
    this.ProviderName = selectedProviders.label
    this.logoUrl = selectedProviders.label2
    console.log(accountNumber)
    this.productRequest = {
      countryIso: this.CountryIso,
      providerCode: this.ProviderCode,
      receiveCountryName: "",
      providerName: this.ProviderName,
      accountNumber: "1" + "" + accountNumber, //923440118470
      logoUrl: this.logoUrl,
      logRequest: true
    }
    this.boolShowAmount = true
    console.log(this.productRequest)
    this.customService.GetProducts(this.productRequest).subscribe((res: any) => {
      this.intlProductRefenceNumber = res.result.pridReferenceNumber
      this.Products = res.result.items
      this.dmstcProductOptions = []
      this.Loader = false
      for (let i = 0; i < this.Products.length; i++) {
        this.dmstcProductOptions.push({ value: this.Products[i].skuCode, label: this.Products[i].defaultDisplayText, label2: this.Products[i].skuCode })
      }
      console.log(this.dmstcProductOptions)
      this.Loader = false
    })

  }
  changeProvider() {
    this.boolDmstcAmountValue = false
    this.dmstcAmountValue = 0

    this.boolShowAmount = false
    this.selectedItem = null
    this.selectedItemProduct = null
    this.GetDomesticProviders()
  }
  onItemProductClick(item) {
    console.log(item)
    this.selectedItemProduct = null
    if (this.selectedItemProduct === item) {
      this.selectedItemProduct = null;
    } else {
      this.selectedItemProduct = item;
      this.changeIntlProduct(item)
    }
    this.boolShowAmount = true
  }
  changeIntlProduct(id) {
    this.boolIntlAmountValue = false
    this.Loader = true
    console.log(id.value)
    this.intlSelectedProduct = this.Products.find(product => product.skuCode == id.value)
    console.log(this.intlSelectedProduct)
    this.boolAmountRange = true
    if (this.intlSelectedProduct.maximum.sendValue == this.intlSelectedProduct.minimum.sendValue) {
      this.intlAmountValue = this.intlSelectedProduct.maximum.sendValue
      this.boolIntlAmountValue = true

      this.dmstcAmountValue = this.intlSelectedProduct.maximum.sendValue
      this.boolDmstcAmountValue = true
    }
    this.Loader = false
  }
  backSelectProduct() {
    this.boolDmstcAmountValue = false
    this.dmstcAmountValue = 0
    this.selectedItemProduct = null;
    // this.boolShowAmount=false
  }
  async AddToCartDomestic(amount, countryCode, recieverPhone, firstName, lastName) {
    var SKU = this.intlSelectedProduct.skuCode
    var commissionRate = this.intlSelectedProduct.commissionRate.toString()
    var processingMode = this.intlSelectedProduct.processingMode
    var redemptionMechanism = this.intlSelectedProduct.redemptionMechanism
    var displayText = this.intlSelectedProduct.defaultDisplayText
    var pridReferenceNumber = this.intlProductRefenceNumber

    this.Loader = true
    const sender_Id = parseInt(this.Customer_Sender_Id, 10)
    const totalAmount = parseInt(amount, 10)

    this.CartTotalAmount = this.CartTotalAmount + totalAmount

    var recieverReq = {
      firstName: firstName,
      lastName: lastName,
      mobileNumber1: recieverPhone,
      mobileNumber2: "",
      address: "",
      email: "",
      customerPhoneNumber: "1234567890",
      sender_Customer_UserId: sender_Id
    }
    var RecieverId
    this.userService.CreatePridReciever(recieverReq).subscribe((res: any) => {
      console.log(res)
      RecieverId = res.id
      console.log(RecieverId)
      var estimatePayload = {
        sendValue: totalAmount,
        skuCode: SKU,
        batchItemRef: pridReferenceNumber,
        uatNumber: pridReferenceNumber,
        commissionRate: commissionRate,
        processingMode: processingMode,
        redemptionMechanism: redemptionMechanism,
        logRequest: true,
        pridReferenceNumber: pridReferenceNumber,
        defaultDisplayText: displayText,
        recieverId: RecieverId,
        sender_Customer_UserId: sender_Id
      }
      console.log(estimatePayload)
      this.customService.EstimatePrice(estimatePayload).subscribe((estimate: any) => {
        this.internationalEstimatePrice = estimate

      })
    })

    this.Loader = false

   setTimeout(()=>{
    console.log(RecieverId)
    this.OrderItem.push({
      pridReferenceNumber: pridReferenceNumber,
      sku: SKU,
      productType: 1,
      retailPrice: amount,
      quantity: 1,
      totalRetailPrice: amount * 1,
      orderId: 0,
      orderNumber: "",
      discountPercentage: 0,
      retailCost: 0,
      totalRetailCost: 0,
      prideComissionPercentage: 0,
      pridProfit: 0,
      isProcessed: false,
      isTestRecord: false,
      country: this.CountryIso,
      providerName: this.ProviderName,
      productDisplayText: displayText,
      logoUrl: this.logoUrl,
      phoneNumber: countryCode + "" + recieverPhone,
      productName: "",
      recieverId:RecieverId
    })
    console.log(this.OrderItem)
   },1000)

    this.Loader = false
    Swal.fire("Success", "Item added to cart successfully", 'success')
    this.saveObjectToCookie(this.OrderItem)
  }
  saveObjectToCookie(object) {
    this.cookieService.set('orderCookie', JSON.stringify(object));
  }
  }
